import React from 'react';
import Modal from './Modal';

/**
 * Shared yes/no confirmation popup, for destructive actions that need a
 * "are you sure?" step before anything actually happens -- same
 * title/message/two-button shape "Delete Exercise?"/"Delete Routine?"
 * already established ad hoc in RoutinePicker.jsx/WorkoutLog.jsx, pulled
 * into one component so every NEW delete-button confirmation added per
 * direct user request ("whenever a delete button is tapped... prompt to
 * confirm") doesn't duplicate that same Modal/paragraph/button-row
 * boilerplate again. Those two pre-existing bespoke confirm dialogs were
 * left as-is rather than migrated -- they already work, this just avoids
 * a fourth and fifth copy of the same pattern for the newly-added spots.
 */
const ConfirmModal = ({
  title,
  message,
  confirmLabel = "Delete",
  // Shown in place of confirmLabel while the action is in flight -- e.g.
  // "Discarding..." for a Cancel Mission-style action, vs. the default
  // "Deleting..." every pre-existing delete-confirmation call site expects.
  confirmingLabel = "Deleting...",
  cancelLabel = "Cancel",
  confirming = false,
  onConfirm,
  onCancel,
  tabKey
}) => (
  <Modal title={title} tabKey={tabKey} onClose={onCancel}>
    <p style={{ fontFamily: "'Anonymous Pro', monospace", fontSize: "14px", color: "#232526", margin: "0 0 14px 0" }}>
      {message}
    </p>
    <div style={{ display: "flex", gap: "12px" }}>
      <button
        type="button"
        onClick={onConfirm}
        disabled={confirming}
        className="comic-btn comic-btn--end"
        style={{ flex: 1 }}
      >
        {confirming ? confirmingLabel : confirmLabel}
      </button>
      <button
        type="button"
        onClick={onCancel}
        disabled={confirming}
        className="comic-btn comic-btn--done"
        style={{ flex: 1 }}
      >
        {cancelLabel}
      </button>
    </div>
  </Modal>
);

export default ConfirmModal;
